
import { Vue, Component, Prop } from 'vue-property-decorator'

const sizeClasses = {
  s: 'btn-loader_s',
  m: 'btn-loader_m'
}

@Component({
  name: 'BtnLoader'
})
export default class BtnLoader extends Vue {
  @Prop({ type: String, required: true, default: 'm' }) size!: string

  get btnLoaderSizeClass() {
    return sizeClasses[this.size]
  }
}
